import styled from "styled-components";

interface HeaderProps {
  isTransparent?: boolean;  // 투명 배경 여부
  isScrolled?: boolean;     // 스크롤 여부
}

interface HamburgerButtonProps {
  isOpen?: boolean;
}

export const HeaderContainer = styled.header<HeaderProps>`
  width: 100%;
  height: 60px;
  padding-left: 240px;
  padding-right: 240px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  max-width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  background-color: ${({ isTransparent, isScrolled }) => 
    isTransparent && !isScrolled ? 'transparent' : 'rgba(255, 255, 255, 0.6)'};
  backdrop-filter: ${({ isTransparent, isScrolled }) =>
    isTransparent && !isScrolled ? 'none' : 'blur(8px)'};
  
  @media (max-width: 1920px) {
    padding-left: 240px;
    padding-right: 240px;
  }
  
  @media (max-width: 1700px) {
    padding-left: 160px;
    padding-right: 160px;
  }
  
  @media (max-width: 1440px) {
    padding-left: 80px;
    padding-right: 80px;
  }
  
  @media (max-width: 768px) {
    display: flex;
    height: 60px;
    padding: 0 20px;
    background-color: ${({ isTransparent, isScrolled }) => 
      isTransparent && !isScrolled ? 'transparent' : 'rgba(255, 255, 255, 0.6)'};
    backdrop-filter: ${({ isTransparent, isScrolled }) =>
      isTransparent && !isScrolled ? 'none' : 'blur(8px)'};
  }
`;

export const LogoWrapper = styled.div`
  position: relative;
  cursor: pointer;

  @media (max-width: 768px) {
    img {
      width: 48px;
      height: 24px;
    }
  }
`;

export const NavContainer = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 80px;
  
  @media (max-width: 1920px) {
    gap: 80px; /* 유지 */
  }

  @media (max-width: 768px) {
    display: none; // 모바일에서는 기존 네비게이션 숨김
  }
`;

export const NavText = styled.div<HeaderProps>`
  color: ${({ isTransparent, isScrolled }) => 
    isTransparent && !isScrolled ? 'white' : '#1D1D1D'};
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  line-height: 28px;
  word-wrap: break-word;
  text-decoration: none !important;
  transition: color 0.3s ease;
  
  @media (max-width: 1920px) {
    font-size: 16px;
    line-height: 28px;
  }

  @media (max-width: 768px) {
    color: #1D1D1D;  // 모바일에서는 항상 진한 글씨
  }
`;

export const NavItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  text-decoration: none !important;

  &:hover {
    text-decoration: none !important;
    
    ${NavText} {
      color: #FF4F00;
      text-decoration: none !important;
    }
  }
`;

// BannerContainer는 필요한 경우에만 유지
export const BannerContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #1D1D1D;
  position: relative;
  padding: 0 40px;
  
  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

// 새로운 모바일 메뉴 관련 컴포넌트들
export const HamburgerButton = styled.button<HamburgerButtonProps>`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  position: absolute;
  right: 20px;
  z-index: 1001; /* 메뉴 위에 표시되도록 함 */
  
  @media (max-width: 768px) {
    display: ${({ isOpen }) => isOpen ? 'none' : 'block'};
  }

  img {
    width: 24px;
    height: 24px;
  }
`;

export const MobileNav = styled.div<{ isOpen: boolean }>`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: auto;
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 100%; 
    height: 100vh;
    background-color: #1D1D1D;
    z-index: 1000;
    overflow: hidden;
    transition: right 0.3s ease;
  }
`;

export const MobileNavContent = styled.div`
  padding: 140px 40px 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: relative;
  
  @media (max-width: 480px) {
    padding: 140px 30px 0;
    gap: 24px;
  }
`;

export const MobileNavItem = styled.div`
  color: white;
  font-size: 48px;
  font-family: "T1", "Montserrat", sans-serif;
  font-weight: bold;
  font-style: normal;
  line-height: 70px;
  letter-spacing: -1%;
  cursor: pointer;
  text-align: left;
  padding: 10px 0;
  transition: color 0.2s;
  
  &:hover {
    color: #FF4F00;
  }
  
  @media (max-width: 480px) {
    font-size: 48px;
    line-height: 56px;
    padding: 8px 0;
  }
`;

export const MobileHeader = styled.div`
  width: 100%;
  height: 60px;
  padding: 0 40px; /* 좌우 패딩 조정 */
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  top: 0;
  box-sizing: border-box;
  
  @media (max-width: 480px) {
    padding: 0 30px;
  }
`;

export const MobileStatusBar = styled.div`
  display: none;  // 시계 부분 제거
`;

export const MobileDivider = styled.div`
  margin-top: 24px;
  margin-left: 0;
  width: 100%;
  height: 1px;
  background-color: white;
  opacity: 0.2;
  position: absolute;
  bottom: 104px;  /* SNS 아이콘(50px) + 간격(30px) + 구분선 높이(24px) */
  left: 40px;
  
  @media (max-width: 480px) {
    margin-left: 0;
    width: calc(100% - 60px);
    left: 30px;
  }
`;

export const MobileSNS = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  bottom: 50px;
  left: 40px;
  
  @media (max-width: 480px) {
    width: calc(100% - 60px);
    left: 30px;
  }
`;

export const SNSIcon = styled.a`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  color: white;
  font-size: 24px;
  position: absolute; /* fixed에서 absolute로 변경 */
  top: 15px;
  right: 20px;
  z-index: 1002;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  @media (max-width: 768px) {
    display: flex;
  }
`;

// 배경 어둡게 처리를 위한 오버레이 추가
export const MobileMenuOverlay = styled.div<{ isOpen: boolean }>`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
    transition: opacity 0.3s ease;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  }
`; 